var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"commission-terms"},[_c('h1',[_vm._v("How to know the terms of commissions of advertising platforms?")]),_c('p',[_vm._v("In the \"Commission\" section, when you select an advertising platform, the commission terms for enrollments will be displayed. ")])])
}]

export { render, staticRenderFns }